import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component(resolve) {
        require(["../page/Home.vue"], resolve);
      }
    },
    {
      path: "/modelone",
      name: "modelone",
      component(resolve) {
        require(["../page/modelOne.vue"], resolve);
      }
    },
    {
      path: "/modeltwo",
      name: "modeltwo",
      component(resolve) {
        require(["../page/modelTwo.vue"], resolve);
      }
    },
    {
      path: "/modelthree",
      name: "modelthree",
      component(resolve) {
        require(["../page/modelThree.vue"], resolve);
      }
    },
    {
      path: "/modelsix",
      name: "modelsix",
      component(resolve) {
        require(["../page/modelSix.vue"], resolve);
      }
    },
    {
      path: "/categoryPage",
      name: "categoryPage",
      component(resolve) {
        require(["../page/categoryPage.vue"], resolve);
      }
    },
    {
      path: "/categoryPageLy",
      name: "categoryPageLy",
      component(resolve) {
        require(["../page/categoryPageLy.vue"], resolve);
      }
    },
    {
      path: "/categoryCustomPageLy",
      name: "categoryCustomPageLy",
      component(resolve) {
        require(["../page/categoryCustomPageLy.vue"], resolve);
      }
    },
    {
      path: "/adminOverview",
      name: "adminOverview",
      component(resolve) {
        require(["../page/adminOverview.vue"], resolve);
      }
    },
    {
      path: "/essence",
      name: "essence",
      // meta:{
      //   title:"中山影像-专题策划",
      // },
      component(resolve) {
        require(["../page/essenceTopics.vue"], resolve);
      }
    },
    {
      path: "/modelad",
      name: "modelad",
      component(resolve) {
        require(["../page/modelAd.vue"], resolve);
      }
    },
    {
      path: "/allclassnew",
      name: "allclassnew",
      component(resolve) {
        require(["../page/allClassification.vue"], resolve);
      }
    },
    {
      path: "/modeltwonew",
      name: "modeltwonew",
      component(resolve) {
        require(["../page/modelTwoNew.vue"], resolve);
      }
    },
    {
      path: "/login",

      name: "Login",
      component(resolve) {
        require(["../page/login.vue"], resolve);
      }
    },
    {
      path: "/special",
      name: "Special",
      component(resolve) {
        require(["@/page/topic.vue"], resolve);
      }
    },
    {
      path: "/allclassad",
      meta: {
        title: ""
        // requireAuth: true,  //表示进入这个路由是需要登录的
      },
      name: "allclassad",
      component(resolve) {
        require(["@/page/modelAd.vue"], resolve);
      }
    },
    {
      path: "/search",
      meta: {
        title: ""
        // requireAuth: true, //表示进入这个路由是需要登录的
      },
      name: "Search",
      component(resolve) {
        require(["@/page/searchFilter.vue"], resolve);
      }
    },
    {
      path: "/searchSingle",
      meta: {
        title: ""
      },
      name: "searchSingle",
      component(resolve) {
        require(["@/page/searchSingleFilter.vue"], resolve);
      }
    },
    {
      path: "/searchtwo",
      meta: {
        title: ""
        // requireAuth:true,
      },
      name: "SearchTwo",
      component(resolve) {
        require(["@/page/searchFilterTwo.vue"], resolve);
      }
    },
    {
      path: "/intopic",
      meta: {
        title: ""
        // requireAuth: true,  //表示进入这个路由是需要登录的
      },
      name: "IntoPic",
      component(resolve) {
        require(["@/page/intoPic.vue"], resolve);
      }
    },
    {
      path: "/recommend",
      name: "recommend",
      component(resolve) {
        require(["@/page/recommend.vue"], resolve);
      }
    },
    {
      path: "/detail", //没有开支付的租户中图页面
      meta: {
        title: ""
        //requireAuth: true, //表示进入这个路由是需要登录的
      },
      name: "Detail",
      component(resolve) {
        require(["@/page/toBigPic.vue"], resolve);
      },
      props: true
    },
    {
      path: "/zhifuDetail", //已经开支付的租户中图页面
      meta: {
        title: ""
        //requireAuth: true, //表示进入这个路由是需要登录的
      },
      name: "Detail",
      component(resolve) {
        // require(["@/page/toBigPic.vue"], resolve);
        require(["@/page/zhifuToBigPic.vue"], resolve);
      },
      props: true
    },
    {
      //套餐展示
      path: "/PackagePrice",
      name: "PackagePirce",
      meta: {
        title: "套餐价格"
      },
      component(resolve) {
        require(["../page/PackagePrice.vue"], resolve);
      }
    },
    {
      //购物车
      path: "/shoppingCart",
      name: "shoppingCart",
      component(resolve) {
        require(["../page/shoppingCart.vue"], resolve);
      }
    },
    {
      //图片清单结算
      path: "/picpayList",
      name: "picpayList",
      component(resolve) {
        require(["../page/picpayList.vue"], resolve);
      }
    },
    {
      //套餐支付
      path: "/setMealPay",
      name: "setMealPay",
      component(resolve) {
        require(["../page/setMealPay.vue"], resolve);
      }
    },
    {
      //套餐支付
      path: "/setOnePay",
      name: "setOnePay",
      component(resolve) {
        require(["../page/setOnePay.vue"], resolve);
      }
    },
    {
      path: "/spread",
      name: "spread",
      component(resolve) {
        require(["@/page/spreadPage.vue"], resolve);
      }
    },
    {
      path: "/personal",
      meta: {
        title: ""
        // requireAuth: true,  //表示进入这个路由是需要登录的
      },
      name: "Personal",
      component(resolve) {
        require(["../page/Personal.vue"], resolve);
      }
    },
    {
      path: "/register",
      name: "Register",
      component(resolve) {
        require(["../page/register.vue"], resolve);
      }
    },
    {
      path: "/service",
      name: "valueaddservice",
      component(resolve) {
        require(["../page/valueaddservice.vue"], resolve);
      }
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component(resolve) {
        require(["../page/aboutUs.vue"], resolve);
      }
    },
    // modelAdBeforeLogin
    {
      path: "/loginbf",
      name: "loginbf",
      component(resolve) {
        require(["../page/modelAdBeforeLogin.vue"], resolve);
      }
    },
    {
      path: "/freqes",
      component(resolve) {
        require(["../page/frequentlyQuestions.vue"], resolve);
      }
    },
    {
      path: "/quesanswer",
      component(resolve) {
        require(["../page/questionAnswer.vue"], resolve);
      }
    },
    {
      path: "/chatus",
      component(resolve) {
        require(["../page/chatUs.vue"], resolve);
      }
    },
    {
      path: "/shopread",
      component(resolve) {
        require(["../page/shopRead.vue"], resolve);
      }
    },
    {
      path: "/sellread",
      component(resolve) {
        require(["../page/sellRead.vue"], resolve);
      }
    },
    {
      path: "/webterms",
      component(resolve) {
        require(["../page/websiteTerms.vue"], resolve);
      }
    },
    {
      path: "/copyright",
      component(resolve) {
        require(["../page/copyRight.vue"], resolve);
      }
    },
    {
      path: "/salesagency",
      component(resolve) {
        require(["../page/salesAgency.vue"], resolve);
      }
    },
    {
      path: "/resetpass",
      component(resolve) {
        require(["../page/resetPassword.vue"], resolve);
      }
    },
    {
      path: "/gnsAuth",
      component(resolve) {
        require(["../page/gnsAuth.vue"], resolve);
      }
    },
    {
      path: "/taskCollection",
      component(resolve) {
        require(["../page/taskCollection.vue"], resolve);
      } //任务征集
    },
    {
      path: "/OngoingTask",
      component(resolve) {
        require(["../page/OngoingTask.vue"], resolve);
      } //进行中的任务详情
    },
    // {
    //   path:'/MyTask',
    //   component(resolve){
    //     require(['../page/MyTask.vue'],resolve)
    //   }            //任务征集详情
    // },
    {
      path: "/uploadWork",
      component(resolve) {
        require(["../page/uploadWork.vue"], resolve);
      } //上传文件
    },
    //************************电信用户登录页*************************************//
    {
      path: "/loginAd",

      name: "LoginAd",
      component(resolve) {
        require(["../page/loginAd.vue"], resolve);
      }
    },
    //************************电信用户登录页导航*************************************//
    {
      path: "/homeAd",

      name: "homeAd",
      component(resolve) {
        require(["../page/homeAd.vue"], resolve);
      }
    },
    {
      path: "/lyLogin",
      name: "lyLogin",
      component(resolve) {
        require(["../page/lyLogin.vue"], resolve);
      }
    },
    {
      path: "/modelvideo",
      name: "modelvideo",
      component(resolve) {
        require(["../page/video/modelvideo.vue"], resolve);
      }
    },
    {
      path: "/noLoginModel",
      name: "noLoginModel",
      component(resolve) {
        require(["../page/noLoginModel.vue"], resolve);
      }
    },
    {
      path: "/noLoginModelFP",
      name: "noLoginModelFP",
      component(resolve) {
        require(["../page/noLoginModelFP.vue"], resolve);
      }
    },
    {
      path: "/peoplevisual",
      name: "peoplevisual",
      component(resolve) {
        require(["../page/peoplevisual.vue"], resolve);
      }
    },
    {
      path: "/loginModel",
      name: "loginModel",
      component(resolve) {
        require(["../page/loginModel.vue"], resolve);
      }
    },
    {
      path: "/creativePhoto",
      name: "creativePhoto",
      component(resolve) {
        require(["../page/creativePhoto.vue"], resolve);
      }
    },
    {
      path: "/modelvideo2",
      name: "modelvideo2",
      component(resolve) {
        require(["../page/video/modelvideo2"], resolve);
      }
    },
    {
      path: "/modelvideo3",
      name: "modelvideo3",
      component(resolve) {
        require(["../page/video/modelvideo3"], resolve);
      }
    },
    {
      path: "/modelvideo4",
      name: "modelvideo4",
      component(resolve) {
        require(["../page/video/modelvideo4"], resolve);
      }
    },
    {
      path: "/territoryList",
      name: "territoryList",
      component(resolve) {
        require(["../page/territoryList.vue"], resolve);
      }
    },
    {
      path: "/territoryListLocal",
      name: "territoryListLocal",
      component(resolve) {
        require(["../page/territoryList2.vue"], resolve);
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js